import { useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { SEARCH_AUDIT_LOGS } from "../../../graphql/log-gql";
import { IAuditLogResponse, IAuditTransaction } from "../../../types/log";
import AccordionContainer from "../../common/accordion-container";
import SpinnerOverlay from "../../common/spinner/spinner";
import AuditLogTable from "./audit-log-table";
import LogSearchForm from "./log-search-form";
import { FetchPolicyOption } from "../../../services/apollo/apollo";
import { notifySuccess } from "../../../services/notification";
import { Alert } from "reactstrap";
import { InfoIcon } from "../../common/icons";

export default function AuditLogProvider() {
  const [results, setResults] = useState<IAuditTransaction[]>();
  const [alertMessage, setAlertMessage] = useState<String>();
  const [search, { loading }] = useLazyQuery<IAuditLogResponse>(SEARCH_AUDIT_LOGS, FetchPolicyOption.NoCache);

  const handleSubmit = (startDate: string, endDate: string) => {
    setResults(undefined);

    setAlertMessage("")
    search({
      variables: {
        from: startDate,
        to: endDate
      }
    }).then(response => {
      setResults(response.data?.auditLogs);
      notifySuccess('Request completed');
      setTimeout(() => setAlertMessage("Please select an expandable entity to view more details"), 100);
    })
  };

  const handleReset = () => setResults(undefined);

  return (
    <AccordionContainer title="Search Audit Logs">
      <LogSearchForm onSubmit={handleSubmit} onReset={handleReset} searching={loading} />

      <AuditLogTable data={results} pageSize={20} />
      {alertMessage &&
        <Alert color="info">
          <InfoIcon /> {alertMessage}
        </Alert>
      }
      {loading && <SpinnerOverlay />}
    </AccordionContainer>
  );
}
